module.exports = __webpack_public_path__ + "static/media/profileImage.6b10f99a.jpg";